<template>
  <div class="EnergyFlowKanBan">
    <div class="EnergyFlowKanBan">
      <el-scrollbar style="height:50px;width: 100%;">
        <div class="KanBantop">
          <span v-show="false">{{ unitId }}</span>
          <div class="choice">
            能流图：
            <el-select v-model="chartId" placeholder="请选择" @change="chartChange">
              <el-option label="现场布置图" value="1"> </el-option>
            </el-select>
          </div>
          <div class="line"></div>
          <div class="choice">
            类型：
            <el-select v-model="energyType" placeholder="请选择">
              <el-option label="电" :value="1"> </el-option>
            </el-select>
          </div>
          <div class="line"></div>

          <div class="timer">
            时间：
            <el-date-picker v-model="value1" type="daterange" :picker-options="pickerOptions" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
            <span class="query" @click="getEnergyFlowDiagram_fn">查询 <i class="el-icon-search"></i></span>
          </div>
          <div class="line"></div>
          <div class="display-data">
            显示数据：
            <el-radio v-model="radio" label="1">数值</el-radio>
            <el-radio v-model="radio" label="2">占比</el-radio>
          </div>
        </div>
      </el-scrollbar>

      <div class="danwei">单位：{{ energyType | danwei_fn }}</div>
      <div id="proportion" style="width:100%;height:95%"></div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-if="isMask">
      <i class="el-icon-loading" style="color:#409eff;font-size:60px"></i>
    </div>
  </div>
</template>

<script  >
  import {
    findUnitInfo,
    getEnergyFlowDiagram,
    diagramHintFind,
  } from "../../api/energyFlow";
  import { getAllEnergyType } from "../../api/energySubType";
  import * as echarts from "echarts";
  import $ from "jquery";
  var proportion;
  export default {
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 86400000;
          },
        },
        energyType: "",
        energyTypeData: [],
        isMask: false, //遮罩层
        areaTree: false,
        radio: "1",
        value1: "",
        treeData: [],
        clickData: {},
        ROOT_PATH: "https://echarts.apache.org/examples",
        defaultProps: {
          children: "children",
          label: "unitName",
        },
        option: {
          title: {
            subtext: "",
            left: "center",
          },
          tooltip: {
            trigger: "item",
            triggerOn: "mousemove",
          },
          series: [
            {
              type: "sankey",
              nodeAlign: "left",
              bottom: 75.0,
              data: [],
              links: [],
              emphasis: {
                focus: "adjacency",
              },
              levels: [
                {
                  depth: 0,
                  itemStyle: {
                    color: "#fbb4ae",
                  },
                  lineStyle: {
                    color: "source",
                    opacity: 0.6,
                  },
                },
                {
                  depth: 1,
                  itemStyle: {
                    color: "#b3cde3",
                  },
                  lineStyle: {
                    color: "source",
                    opacity: 0.6,
                  },
                },
                {
                  depth: 2,
                  itemStyle: {
                    color: "#ccebc5",
                  },
                  lineStyle: {
                    color: "source",
                    opacity: 0.6,
                  },
                },
                {
                  depth: 3,
                  itemStyle: {
                    color: "#decbe4",
                  },
                  lineStyle: {
                    color: "source",
                    opacity: 0.6,
                  },
                },
              ],
              lineStyle: {
                curveness: 0.5,
              },
            },
          ],
          label: {
            color: "#fff", // 设置标签文字颜色为黑色
          },
        },
        links: [],
        nodes: [],
        optionsData: [], //下拉框
        chartId: "1", //选中的能流图
        chartName: "现场布置图", //选中的能流图名字
        todayTimer: 0,
        flowList: [], //损耗阈值
      };
    },
    watch: {
      unitId() { },
    },
    mounted() {
      //获取能源类型
      console.log(1111111);
      this.init();
      var date = new Date();

      var today = new Date(
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
      // console.log("时间",today.getTime()- 28800000);
      this.todayTimer = today.getTime() - 28800000;

      var res = {
        code: 200,
        message: "操作成功",
        data: [
          {
            id: "ff4f67fa0d3f485289331562e18bc870",
            name: "产品1号配电房",
            upId: "0",
            createTime: 1676602790000,
            facility: {
              facilityName: "产品采集供电局电表数据",
              facilityDifference: 80760,
              proportion: 100,
            },
            children: [
              {
                id: "0d2d9daa684948e484a3d1ce9f5ef135",
                name: "4102",
                upId: "ff4f67fa0d3f485289331562e18bc870",
                createTime: 1676601291000,
                facility: {
                  facilityName: "产品4102-楼顶APR105",
                  facilityDifference: 3505.81,
                  proportion: 4.0,
                },
                children: [],
              },
              {
                id: "24d581700e1f47bbb317f6549dc55038",
                name: "4101",
                upId: "ff4f67fa0d3f485289331562e18bc870",
                createTime: 1676601319000,
                facility: {
                  facilityName: "产品4101-楼顶APR106",
                  facilityDifference: 5964.93,
                  proportion: 7.0,
                },
                children: [],
              },
              {
                id: "3e58980a1a174f82987cbb894e4ab8ba",
                name: "4104",
                upId: "ff4f67fa0d3f485289331562e18bc870",
                createTime: 1676601359000,
                facility: {
                  facilityName: "产品4104-楼顶APR101",
                  facilityDifference: 1124.73,
                  proportion: 1.0,
                },
                children: [],
              },
              {
                id: "83b13e29d81f4504b4c3a3bbb863d06b",
                name: "4071",
                upId: "ff4f67fa0d3f485289331562e18bc870",
                createTime: 1676601478000,
                facility: {
                  facilityName: "产品4071-联络至母线",
                  facilityDifference: 0.0,
                  proportion: 0.0,
                },
                children: [],
              },
              {
                id: "94fa5273c84542af990289983c665af5",
                name: "4105",
                upId: "ff4f67fa0d3f485289331562e18bc870",
                createTime: 1676601495000,
                facility: {
                  facilityName: "产品4105-备用",
                  facilityDifference: 0.0,
                  proportion: 0.0,
                },
                children: [],
              },
              {
                id: "c0e6ddab0b4e45849a794bf4f1f65afa",
                name: "4103",
                upId: "ff4f67fa0d3f485289331562e18bc870",
                createTime: 1676601546000,
                facility: {
                  facilityName: "产品4103-备用",
                  facilityDifference: 0.0,
                  proportion: 0.0,
                },
                children: [],
              },
              {
                id: "d04dd89055554bb8ae3a32a73fbb5950",
                name: "4131",
                upId: "ff4f67fa0d3f485289331562e18bc870",
                createTime: 1676601561000,
                facility: {
                  facilityName: "产品4131-楼顶APR103",
                  facilityDifference: 34853.0,
                  proportion: 43.0,
                },
                children: [],
              },
              {
                id: null,
                name: "损耗",
                upId: null,
                createTime: null,
                facility: {
                  facilityName: "损耗",
                  facilityDifference: 35311.53,
                  proportion: 44.0,
                },
                children: [],
              },
            ],
          },
        ],
      };
      var data = res.data.filter((item) => item.facility.facilityName != null);
      this.handleDataNum(data);
      // this.dateValue = today
    },
    computed: {
      unitId() {
        return this.$store.unitStore.state.nowUnit;
      },
    },
    methods: {
      init() {
        proportion = echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.option, true);

        //获取损耗阈值
      },
      //树形结构数据
      findUnitInfoFun() {
        var d = {
          unitId: this.unitId.id,
        };
        findUnitInfo(d).then((res) => {
          //  res.data =  JSON.parse(JSON.stringify(res.data).replace(/name/g, 'unitName'))
          var data = res.data.children;
          data.forEach((item) => {
            item.children = [];
          });
          var newData = data.filter((item) => item.appType == "能流分析");
          this.optionsData = newData;
          this.chartId = newData[0].id;
          this.chartName = newData[0].name;
          //  this.clickData = data[0].children[0]
        });
      },

      //获取能源类型
      getAllEnergyType_fn() {
        getAllEnergyType().then((res) => {
          if (res.code == 200) {
            this.energyTypeData = res.data;
            if (this.energyTypeData.length != 0) {
              this.energyType = res.data[0].appTypeNo;
            }
          }
        });
      },
      //获取能流图
      getEnergyFlowDiagram_fn() {
        if (this.value1 == "") {
          this.$message({ message: `请选择时间！`, type: "warning" });
          return;
        }
        var d = {
          endTime: this.value1[1].getTime(),
          nodeId: this.chartId,
          startTime: this.value1[0].getTime(),
          energyType: this.energyType,
        };

        getEnergyFlowDiagram(d).then((res) => {
          if (res.code == 200) {
            if (this.radio == 1) {
            } else {
              this.handleDataPer(data);
            }
          } else {
            setTimeout(() => {
              this.isMask = false;
            }, 2000);
            this.$message({ message: `获取失败，${res.message}`, type: "error" });
          }
        });
      },
      //处理数据数值(新)
      handleDataNum(data) {
        var ChuanData = data;
        var mynodes = [{ name: this.chartName }];
        var mylinks = [];
        var noeName = this.chartName;
        var that = this;
        var recursiveFunction = function () {
          const getStr = function (list) {
            list.forEach(function (row) {
              if (row.children) {
                if (row.children.length != 0) {
                  if (row.facility == null) {
                    row.facility = {
                      facilityDifference: "",
                      proportion: 0,
                    };
                  }
                  //判断是否为损耗
                  row.children.forEach((item) => {
                    item.farterName =
                      row.name + " " + row.facility.facilityDifference;
                    item.type = "正常";
                    if (item.name == "损耗") {
                      item.name = row.name + " 损耗";
                      item.type = "损耗";
                    }
                  });
                  //判断是否是第二层
                  if (row.upId == 0) {
                    mylinks.push({
                      source: noeName,
                      target: row.name + " " + row.facility.facilityDifference,
                      value: row.facility.facilityDifference,
                    });
                    mynodes.push({
                      name: row.name + " " + row.facility.facilityDifference,
                    });
                  } else {
                    mylinks.push({
                      source: row.farterName,
                      target: row.name + " " + row.facility.facilityDifference,
                      value: row.facility.facilityDifference,
                    });
                    if (row.type == "损耗") {
                      mynodes.push({
                        name: row.name + " " + row.facility.facilityDifference,
                        itemStyle: {
                          color: that.threshold_fn(row.facility.proportion),
                        },
                      });
                    } else {
                      mynodes.push({
                        name: row.name + " " + row.facility.facilityDifference,
                      });
                    }
                  }
                  getStr(row.children);
                } else {
                  if (row.facility == null) {
                    row.facility = {
                      facilityDifference: "",
                      proportion: 0,
                    };
                  }
                  //判断是否是第二层
                  if (row.upId == 0) {
                    mylinks.push({
                      source: noeName,
                      target: row.name + " " + row.facility.facilityDifference,
                      value: row.facility.facilityDifference,
                    });
                    mynodes.push({
                      name: row.name + " " + row.facility.facilityDifference,
                    });
                  } else {
                    mylinks.push({
                      source: row.farterName,
                      target: row.name + " " + row.facility.facilityDifference,
                      value: row.facility.facilityDifference,
                    });
                    if (row.type == "损耗") {
                      mynodes.push({
                        name: row.name + " " + row.facility.facilityDifference,
                        itemStyle: {
                          color: that.threshold_fn(row.facility.proportion),
                        },
                      });
                    } else {
                      mynodes.push({
                        name: row.name + " " + row.facility.facilityDifference,
                      });
                    }
                  }
                }
              }
            });
          };
          getStr(ChuanData);
        };
        recursiveFunction();

        this.option.series[0].data = mynodes;
        this.option.series[0].links = mylinks;

        proportion.setOption(this.option, true);
      },
      //处理数据数值(新)
      handleDataPer(data) {
        var ChuanData = data;
        var mynodes = [{ name: this.chartName }];
        var mylinks = [];
        var noeName = this.chartName;
        var that = this;
        var recursiveFunction = function () {
          const getStr = function (list) {
            list.forEach(function (row) {
              if (row.children) {
                if (row.children.length != 0) {
                  if (row.facility == null) {
                    row.facility = {
                      facilityDifference: "",
                      proportion: null,
                    };
                  }
                  // row.facility.proportion
                  //判断是否为损耗
                  row.children.forEach((item) => {
                    item.farterName = row.name + " " + row.facility.proportion;
                    item.type = "正常";
                    if (item.name == "损耗") {
                      item.name = row.name + " 损耗";
                      item.type = "损耗";
                    }
                  });
                  //判断是否是第二层
                  if (row.upId == 0) {
                    mylinks.push({
                      source: noeName,
                      target: row.name + " " + row.facility.proportion,
                      value: row.facility.proportion,
                    });
                    mynodes.push({
                      name: row.name + " " + row.facility.proportion,
                    });
                  } else {
                    mylinks.push({
                      source: row.farterName,
                      target: row.name + " " + row.facility.proportion,
                      value: row.facility.proportion,
                    });
                    if (row.type == "损耗") {
                      mynodes.push({
                        name: row.name + " " + row.facility.proportion,
                        itemStyle: {
                          color: that.threshold_fn(row.facility.proportion),
                        },
                      });
                    } else {
                      mynodes.push({
                        name: row.name + " " + row.facility.proportion,
                      });
                    }
                  }
                  getStr(row.children);
                } else {
                  if (row.facility == null) {
                    row.facility = {
                      facilityDifference: "",
                      proportion: null,
                    };
                  }
                  //判断是否是第二层
                  if (row.upId == 0) {
                    mylinks.push({
                      source: noeName,
                      target: row.name + " " + row.facility.proportion,
                      value: row.facility.proportion,
                    });
                    mynodes.push({
                      name: row.name + " " + row.facility.proportion,
                    });
                  } else {
                    mylinks.push({
                      source: row.farterName,
                      target: row.name + " " + row.facility.proportion,
                      value: row.facility.proportion,
                    });
                    if (row.type == "损耗") {
                      mynodes.push({
                        name: row.name + " " + row.facility.proportion,
                        itemStyle: {
                          color: that.threshold_fn(row.facility.proportion),
                        },
                      });
                    } else {
                      mynodes.push({
                        name: row.name + " " + row.facility.proportion,
                      });
                    }
                  }
                }
              }
            });
          };
          getStr(ChuanData);
        };
        recursiveFunction();

        mynodes.forEach((item) => {
          if (item.name.includes("null")) {
            item.name = item.name.replace("null", "");
            if (item.name != noeName) {
              item.name = item.name;
            }
          } else {
            if (item.name != noeName) {
              item.name = item.name + "%";
            }
          }
        });

        mylinks.forEach((item) => {
          if (item.source.includes("null")) {
            item.source = item.source.replace("null", "");
            if (item.source != noeName) {
              item.source = item.source;
            }
          } else {
            if (item.source != noeName) {
              item.source = item.source + "%";
            }
          }
          if (item.target.includes("null")) {
            item.target = item.target.replace("null", "");
            item.target = item.target;
          } else {
            item.target = item.target + "%";
          }
        });

        this.option.series[0].data = mynodes;
        this.option.series[0].links = mylinks;

        proportion.setOption(this.option, true);
      },

      //处理损耗阈值
      threshold_fn(val) {
        var colorArr = [];
        this.flowList.forEach((item) => {
          if (item.color == "red") {
            if (val > item.thresholdValue) {
              colorArr.push(item.color);
            }
          } else {
            if (val <= item.thresholdValue) {
              colorArr.push(item.color);
            }
          }
        });
        return colorArr.length == 0 ? "" : colorArr[0];
      },

      //数据结构点击
      chartChange(item) {
        //  console.log(item);
        this.chartId = item;
        var obj = this.optionsData.filter((item) => item.id == this.chartId);
        this.chartName = "现场布置图";
        //  this.clickData = item
        //  this.areaTree = false
      },
    },
    filters: {
      // 转换单位
      danwei_fn(val) {
        if (val == 36) {
          return "KW·H";
        } else if (val == 237) {
          return "t";
        } else if (val == 361) {
          return "m³";
        } else {
          return "";
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mask {
    width: 100%;

    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2020;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .danwei {
    position: absolute;
    top: 50px;
    left: 20px;
    font-size: 16px;
    color: #fff;
  }

  .EnergyFlowKanBan {
    width: 100%;
    height: 100%;
    background-color: #25354a;
    position: relative;

    .KanBantop {
      width: 100%;
      height: 40px;
      margin-top: 10px;
      color: #ffffff;
      display: flex;
      align-items: center;

      .line {
        width: 1px;
        height: 18px;
        background-color: #999;
        margin: 0px 20px;
      }

      .choice {
        display: flex;
        align-items: center;
        margin-left: 20px;
        position: relative;

        .specific {
          width: 250px;
          height: 30px;
          border: 1px solid #ffffff;
          border-radius: 5px;
          text-align: center;
          line-height: 30px;
          cursor: pointer;

          &.specific-active {
            border-color: #52a1ff;
          }
        }

        .choice-tree {
          position: absolute;
          // padding-top: 40px;
          top: 0px;
          right: 0;
          width: 82%;
          height: 400px;
          max-height: 600px;

          z-index: 9999;

          border-radius: 10px;
        }

        /deep/.el-input__inner {
          background-color: transparent !important;
          color: #ffffff !important;
          height: 34px;
          line-height: 34px;
        }

        /deep/.el-input__icon {
          color: #ffffff !important;
          line-height: 34px;
        }
      }

      .timer {
        display: flex;
        align-items: center;

        /deep/.el-input__inner {
          background-color: transparent;
          padding: 0px 10px;
          height: 36px;
          line-height: 36px;
        }

        /deep/.el-range-separator {
          color: #ffffff !important;
        }

        /deep/.el-range-input {
          background-color: transparent;
          color: #ffffff;
        }

        .query {
          // display: block;
          margin-left: 10px;
          width: 80px;
          height: 32px;
          border: 1px solid #ffffff;
          border-radius: 5px;
          display: flex;
          align-items: center;
          padding-left: 12px;
          justify-content: space-between;
          cursor: pointer;

          i {
            font-size: 16px;
            margin-right: 10px;
            position: relative;
            top: 2px;
          }

          &:hover {
            background-color: #409eff;
          }
        }
      }

      .display-data {
        /deep/.el-radio__label {
          color: #ffffff;
        }
      }
    }
  }
</style>